import { SET_MESSAGE, CLEAR_MESSAGE, SINGLE_TIME } from "../actions/types";

const initialState = {
  postStatus:false
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MESSAGE:
      return { message: payload };

    case CLEAR_MESSAGE:
      return { message: "" };

    case SINGLE_TIME:
      return { postStatus: payload };

    default:
      return state;
  }
}
